<div class="vendor-contacts">
  @if (Contacts.length === 0) {
    <p class="vendor-contacts__empty">No contacts on file yet.</p>
  }

  <div class="vendor-contacts__grid">
    @for (Contact of Contacts; track Contact; let index = $index) {
      <div class="vendor-contact-card">
        <header class="vendor-contact-card__head">
          <div class="vendor-contact-card__title">
            <h3 class="vendor-contact-card__name">
              {{ Contact.firstName }} {{ Contact.lastName }}
            </h3>
            @if (Contact.jobTitle) {
              <p class="vendor-contact-card__job">{{ Contact.jobTitle }}</p>
            }
          </div>
          <div class="vendor-contact-card__roles">
            @for (titlePart of getContactTitle(Contact); track titlePart) {
              <span
                class="chip"
                [class.chip-info]="titlePart.startsWith('Primary')"
                [class.chip-neutral]="!titlePart.startsWith('Primary')"
              >
                {{ titlePart }}
              </span>
            }
          </div>
        </header>

        <dl class="vendor-contact-card__details">
          @if (Contact.email) {
            <div class="vendor-contact-card__row">
              <dt>Email</dt>
              <dd>
                <a
                  class="vendor-contact-card__email"
                  href="mailto:{{ Contact.email }}"
                  >{{ Contact.email }}</a
                >
              </dd>
            </div>
          }
          <div class="vendor-contact-card__row">
            <dt>Phone</dt>
            <dd>
              {{ Contact.phone1 || '—' }}
              @if (Contact.ext) {
                <span class="vendor-contact-card__ext">
                  ext. {{ Contact.ext }}
                </span>
              }
            </dd>
          </div>
        </dl>

        <div class="vendor-contact-card__actions">
          @if (
            !Contact.isPrimaryBid &&
            !Contact.isPrimaryBilling &&
            !Contact.isPrimaryCompliance
          ) {
            <button
              type="button"
              class="vendor-contact-card__delete"
              title="Delete contact"
              aria-label="Delete contact"
              (click)="deleteContact(Contact, index)"
            >
              <i class="bi bi-trash"></i>
            </button>
          }
          <button
            type="button"
            class="btn btn-outline btn-sm vendor-contact-card__edit"
            (click)="changeContact(Contact)"
          >
            <i class="bi bi-pencil me-1"></i>
            Change contact
          </button>
        </div>
      </div>
    }
  </div>
</div>
